<knust-notification></knust-notification>

<mat-sidenav-container autosize>
  <mat-sidenav #sidenav [mode]="sidenavMode" [opened]="showSidenav | async" (openedChange)="changeSidenavState($event)">
    <mat-nav-list (keydown.escape)="dontClose(sidenav)">
      <a routerLink="/home" class="logo-link">
        <img [src]="logoPath" alt="Firmenlogo">
      </a>

      @if (authService.isAdmin()) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/stammdaten" routerLinkActive="active">
          <mat-icon matListItemIcon color="primary">home</mat-icon>
          <div matLine>Stammdaten</div>
        </a>
      }

      <!-- TODO: Consolidate if rules using new control flow -->
      @if ((authService.appInitCompleted | async) === true && (authService.isAdmin() || authService.isPurchasing())) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/lieferanten" routerLinkActive="active"
          >
          <mat-icon matListItemIcon>local_shipping</mat-icon>
          <div matLine>Lieferanten</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true) {
        <a mat-list-item class="navigation-list-link"
           routerLink="/lagerorte" routerLinkActive="active"
        >
          <mat-icon matListItemIcon>gite</mat-icon>
          <div matLine>Lagerorte</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/artikel" routerLinkActive="active"
          >
          <mat-icon matListItemIcon>list_alt</mat-icon>
          <div matLine>Artikelübersicht</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true && (authService.isAdmin() || authService.isPurchasing())) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/wareneingangsbuchung" routerLinkActive="active"
          >
          <mat-icon matListItemIcon>receipt_long</mat-icon>
          <div matLine>Wareneingangsbuchungen</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true && (authService.isAdmin() || authService.isPurchasing())) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/lagerbuchung" routerLinkActive="active"
          >
          <mat-icon matListItemIcon>warehouse</mat-icon>
          <div matLine>Lagerbuchungen</div>
        </a>
      }

      <mat-divider></mat-divider>

      @if ((authService.appInitCompleted | async) === true) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/entnahmen/warenkorb" routerLinkActive="active"
          >
          <mat-icon matListItemIcon [matBadge]="cartItemCount" matBadgeColor="primary" [matBadgeHidden]="cartItemCount === 0">
            shopping_cart
          </mat-icon>
          <div matLine>Warenkorb</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/entnahmen" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <mat-icon matListItemIcon>outbox</mat-icon>
          <div matLine>Entnahmen</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true) {
        <mat-divider></mat-divider>
      }

      @if ((authService.appInitCompleted | async) === true && authService.isAdmin()) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/papierkorb" routerLinkActive="active"
          >
          <mat-icon matListItemIcon>delete_outline</mat-icon>
          <div matLine>Papierkorb</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true) {
        <a mat-list-item class="navigation-list-link"
          routerLink="/benutzer" routerLinkActive="active"
          >
          <mat-icon matListItemIcon>manage_accounts</mat-icon>
          <div matLine>{{authService.isAdmin() ? 'Benutzer' : 'Meine Daten'}}</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true && authService.isAdmin()) {
        <mat-divider></mat-divider>
        <a mat-list-item class="navigation-list-link"
          routerLink="/import" routerLinkActive="active">
          <mat-icon matListItemIcon>import_export</mat-icon>
          <div matLine>Artikel importieren / exportieren</div>
        </a>
        <a mat-list-item class="navigation-list-link"
          routerLink="/berichte" routerLinkActive="active">
          <mat-icon matListItemIcon>query_stats</mat-icon>
          <div matLine>Berichte</div>
        </a>
      }

      @if ((authService.appInitCompleted | async) === true) {
        <mat-divider></mat-divider>
      }

      <!-- Kein Navigationsziel, daher als Button ausgezeichnet (per Tastatur und Screenreader bedienbar) -->
      <a mat-list-item class="navigation-list-link logout-link"
         role="button"
         tabindex="0"
         (keydown.enter)="authService.logout()"
         (keydown.space)="$event.preventDefault(); authService.logout()"
         (click)="authService.logout()">
        <mat-icon matListItemIcon>logout</mat-icon>
        <div matLine>Logout</div>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <main>
      @if (!isLoginWindow) {
        <button (click)="showSidenav.next(true)" mat-flat-button class="menu-button">
          <mat-icon>menu</mat-icon>
          Menü
        </button>
      }

      @if ((authService.appInitCompleted | async) === false) {
        <div class="app-init-notification">
          <p>
            Die Anwendung steht erst zur Verfügung, wenn die Stammdaten eingetragen wurden und Sie sich erneut einloggen.
          </p>
        </div>
      }

      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
